import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../config";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AddCustomerFormModal from "./AddCustomerFormModel";

const DuplicateStyleModal = ({ isOpen, onClose, style,onProductSaved  }) => {
  const [customers, setCustomers] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
   const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isAddCustomerModalOpen, setIsAddCustomerModalOpen] = useState(false);

  const navigate = useNavigate();

  // console.log(style)

const fetchCustomers = async (searchTerm = "") => {
  try {
    const response = await fetch(`${config.BASE_URL}/api/v1/list?customer_name=${searchTerm}`);
    if (!response.ok) {
      throw new Error("Failed to fetch customers");
    }

    const data = await response.json();
    setCustomers(data.data || []);
  } catch (err) {
    setError(err.message);
  } finally {
    setLoading(false);
  }
};


  const handleSearch = (value) => {
  setSearchName(value);
  setDropdownOpen(true);

  if (debounceTimeout) clearTimeout(debounceTimeout);

  const newTimeout = setTimeout(() => {
    fetchCustomers(value); // ✅ Just the raw search string, like "arr"
  }, 300);

  setDebounceTimeout(newTimeout);
};



  const handleCustomerSelect = (customer) => {
    setSelectedCustomer(customer);
    setSearchName(customer.customer_name);
    setDropdownOpen(false);
  };

  const handleClearSearch = () => {
    setSearchName("");
    setSelectedCustomer(null);
    setDropdownOpen(false);
  };

 const handleAddNew = () => {
  setIsAddCustomerModalOpen(true);
};

const handleCustomerCreated = (newCustomer) => {
  setSelectedCustomer(newCustomer);
  setSearchName(newCustomer.customer_name);
  setDropdownOpen(false);
  setIsAddCustomerModalOpen(false);
};


// const handleSaveProduct = async () => {
//     if (!selectedCustomer) {
//         toast.error("Please select a customer before saving.");
//         return;
//     }

//     try {
//         // 1. Fetch original product data
//         const response = await axios.get(`${config.BASE_URL}/api/v1/productDetail/${style}`);

//         if (response.data && response.data.productDetail) {
//             const originalProduct = { ...response.data.productDetail }; 
            
//             // Delete fields that must be unique/new (Mandatory for duplication)
//             delete originalProduct.measurements;
//             delete originalProduct._id;

//             // 2. 🔥 CRITICAL FIX: Component Images ko Hatana
//             if (originalProduct.components) {
//                 // Check if components exist
//                 if (originalProduct.components.jacket) {
//                     // Jacket component se images aur _id hatao
//                     originalProduct.components.jacket.images = [];
//                     delete originalProduct.components.jacket._id; 
//                 }
//                 if (originalProduct.components.pant) {
//                     // Pant component se images aur _id hatao
//                     originalProduct.components.pant.images = [];
//                     delete originalProduct.components.pant._id;
//                 }
//                 // Agar koi aur component ho (e.g., vest), toh uske liye bhi same logic apply hoga
//             }

//             // 3. Create the new product object
//             const newProduct = {
//                 // Spread all properties including modified components
//                 ...originalProduct, 
                
//                 // OVERWRITE fields
//                 customer_id: selectedCustomer._id,
//                 addOrder: true,
                
//                 // CRITICAL FIX (Already done in the previous step, but kept for main product images):
//                 images: [], 
//             };
            
//             const styleVal = style.split("-")[1]?.toLowerCase();
//             if (styleVal === "pant") {
//                 newProduct.description = "Pant";
//             }

//             console.log("New Product Data to be SENT (All images should be []):", newProduct);
            
//             // 4. Send the new product data to the backend
//             const response3 = await axios.put(`${config.BASE_URL}/api/v1/addProduct`, newProduct);
            
//             toast.success("Product duplicated successfully!");
            
//             if (onProductSaved) onProductSaved();
            
//             setTimeout(() => {
//                 onClose();
//             }, 300);
            
//         } else {
//             toast.error("Product data not found.");
//         }
//     } catch (err) {
//         console.error("Error saving product:", err);
//         toast.error("Something went wrong while saving.");
//     }
// };

const handleSaveProduct = async () => {
    if (!selectedCustomer) {
        toast.error("Please select a customer before saving.");
        return;
    }

    try {
        // 1. Fetch original product data
        const response = await axios.get(`${config.BASE_URL}/api/v1/productDetail/${style}`);

        if (response.data && response.data.productDetail) {
            const originalProduct = { ...response.data.productDetail }; 
            
            // Get the new customer name from the selected customer object
            const newCustomerName = selectedCustomer.customer_name;

            // Delete fields that must be unique/new
            delete originalProduct.measurements;
            delete originalProduct._id;

            // 2. Overwrite customerName inside components
            if (originalProduct.components) {
                // Loop through all components (jacket, pant, vest, etc.)
                Object.keys(originalProduct.components).forEach(key => {
                    const component = originalProduct.components[key];
                    if (component) {
                        component.images = []; // Clear images
                        component.customerName = newCustomerName; // UPDATE TO NEW NAME
                        delete component._id; // Remove old ID
                    }
                });
            }

            // 3. Create the new product object
            const newProduct = {
                ...originalProduct, 
                
                // OVERWRITE top-level fields
                customer_id: selectedCustomer._id,
                customerName: newCustomerName, // UPDATE TO NEW NAME AT TOP LEVEL
                addOrder: true,
                images: [],
                quantity: 1, 
            };
            
            const styleVal = style.split("-")[1]?.toLowerCase();
            if (styleVal === "pant") {
                newProduct.description = "Pant";
            }

            // 4. Send the new product data
            await axios.put(`${config.BASE_URL}/api/v1/addProduct`, newProduct);
            
            toast.success("Product duplicated successfully!");
            
            if (onProductSaved) onProductSaved();
            
            setTimeout(() => {
                onClose();
            }, 300);
            
        } else {
            toast.error("Product data not found.");
        }
    } catch (err) {
        console.error("Error saving product:", err);
        toast.error("Something went wrong while saving.");
    }
};

  if (!isOpen) return null;

  return (
    <div className="modal-overlay set_customer_modal">
      <div className="modal-content">
        <div className="popup_header">
          <h4>Set Customer</h4>
          <button type="button" aria-label="Close Modal" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="form-group">
          <label htmlFor="customer-name">Customer</label>
          <div className="search-input-container">
            <input
              id="customer-name"
              type="text"
              value={searchName}
              onChange={(e) => handleSearch(e.target.value)}
              onClick={() => setDropdownOpen(true)}
              placeholder="Search for a customer"
            />
            {searchName && (
              <button
                className="clear-button"
                onClick={handleClearSearch}
                aria-label="Clear search"
              >
                ✕
              </button>
            )}
          </div>

          {dropdownOpen && (
            <div className="customer_search_reaults">
              <h6 className="add_customer_table" onClick={handleAddNew}>
                <span>+</span> Add New
              </h6>
             <table className="table order-table">
                <tbody>
                  {customers.length > 0 ? (
                    customers.map((customer) => (
                      <tr
                        key={customer._id}
                        className={`dropdown-item ${selectedCustomer?._id === customer._id ? "selected" : ""}`}
                        onClick={() => handleCustomerSelect(customer)}
                      >
                        <td>{customer.customer_name}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="1" className="dropdown-item no-results">No results found</td>
                    </tr>
                  )}
                </tbody>
              </table>

            </div>
          )}
        </div>

        <div className="form_footer">
          <button type="button" className="btn" onClick={handleSaveProduct}>
            Save Product
          </button>
        </div>
      </div>
       <AddCustomerFormModal
        isOpen={isAddCustomerModalOpen}
        onClose={() => setIsAddCustomerModalOpen(false)}
        onCustomerCreated={handleCustomerCreated}
      />
    </div>

  );
};

export default DuplicateStyleModal;
